import styles from "./styles.module.css";

export default function Fields({ options, onSelect, selected }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>Fields</div>
      {options.map((x) => {
        return (
          <div
            key={x.code}
            onClick={() => onSelect(x)}
            className={
              selected.value === x.code
                ? styles.item + " " + styles.selected
                : styles.item
            }
          >
            {x.name}
          </div>
        );
      })}
    </div>
  );
}
